

/*
	Source: htdocs/wim/js/core/src/VideoNextUp.js
*/
(function($, wimbledonCore) {
/**
	 * VideoNextUp
	 */
	function VideoNextUp() {
		var logger = new eventsCore.util.Logger('VideoNextUp');
		var nextVideos;
		var autoplay = window.videoAutoplay;
		var maxAutoplay = window.videoAutoplayMax;
		var playCount = 0;
		var userAuto;
		var curIndex = 0;
		var nextVideo;
		var countdownSec = window.videoAutoplayCountdown;
		var countdownRemain = 0;
		var countdownTimer;
		var playNextCallback;

		var nextupElem = '' + 
		'<div class="nextup">' +
		'	<div class="next_banner">' +
		'		<div class="photo">' +
		'			<img src="">' +
		'		</div>' +
		'		<div class="next">' +
		'			<img src="/images/video/btn_next_play.png">' +
		'		</div>' +
		'		<div class="countdown">' +
		'			<div class="label">Starts in...</div>' +
		'			<div class="count"></div>' +
		'			<div class="allow"><a href="#"">disable autoplay</a></div>' +
		'		</div>' +
		'		<div class="next-content">' +
		'			<div class="prompt">Up Next...</div>' +
		'			<div class="title"></div>' +
		'		</div>' +
		'	</div>' +
		'</div>';

		var init = function(id, elem) {
			logger.info('init - id:%o element:%o', id, elem);

			if (elem.find('.nextup').length == 0) {
				elem.find('.content').prepend(nextupElem);

				$('.nextup').on('click', function(event){
					event.preventDefault();
					logger.info('init - nextup click');
					playNext('click');
				});	

				$('.nextup .allow a').on('click', function(event){
					event.preventDefault();
					event.stopPropagation();
					toggleAutoplay();
				});	
			};		

			loadNextupData(id);
			curIndex = 0;
			playCount = 0;

			updateAutoplay();
		};

		/**
		 * configure and display the nextup element
		 */
		var showNextup = function(nextVideo) {
			countdownRemain = countdownSec;

			$('.nextup .photo img').attr('src', nextVideo.thumb);
			$('.nextup .next-content .title').html(nextVideo.title);
			$('.nextup .countdown .count').html(countdownRemain);
			$('.nextup').show();

			if (autoplay && userAuto) {
				$('.nextup .countdown .label').show();
				$('.nextup .countdown .count').show();
				if (!countdownTimer){
					countdownTimer = setTimeout(function(){ updateCountdown() }, 1000);
				}
			}
			else {
				$('.nextup .countdown .label').hide();
				$('.nextup .countdown .count').hide();
			}
		};

		/**
		 * update the countdown interval
		 */
		var updateCountdown = function() {
			countdownRemain -= 1;

			$('.nextup .countdown .count').html(countdownRemain);

			if (countdownRemain > 0){
				countdownTimer = setTimeout(function(){ updateCountdown() }, 1000);
			}
			else if (countdownRemain == 0) {
				playNext('countdown');
			}
		};

		/**
		 * initiate playback of next video through callback
		 */
		var playNext = function(src) {
			logger.info('playNext - next:%o src:%o remain:%o', nextVideo.title, src, countdownRemain);
			countdownRemain = -1;
			removeInterval();

			playCount++;
			$('.nextup').hide();

			

			if (playNextCallback !== null && $.isFunction(playNextCallback)){
                try{ 
                    playNextCallback.call(this, nextVideo);
                }
                catch(e){
                    logger.error('playNext - error - :%o', e);  
                }
            }
		}

		/**
		 * load nextup data based on the selected video id
		 * @param id - id of the selected video
		 */
		var loadNextupData = function(id) {
			var relatedPath = window.relatedContentNextUpPath.replace('[videoid]', id);

			$.ajax({
				dataType: 'json',
				url: relatedPath,
				success: function(data) {
					logger.info('load - success - data:%o', data);
					if (data){
						nextVideos = data.results;
					}
					else {
						logger.warn('load - no nextup data returned: %o', data); 
					}
				},
				error: function(XMLHttpRequest, textStatus, errorThrown) {
					logger.warn('load - error getting video nextup data: %o', errorThrown); 
				}
			});
		};

		/**
		 * handle request for nextVideo
		 * @param id - id of the completed video
		 */
		var getNext = function(id, callback) {
			logger.info('getNext - id:%o next:%o', id, nextVideos);

			playNextCallback = callback;
			curIndex = -1;
			nextVideo = null;

			for (var i=0; i<nextVideos.length; i++) {	
				if (nextVideos[i].cmsId == id) {
					curIndex = i + 1;
					break;
				}
			}

			// at the last video or exceed max plays
			//   do nothing
			if (curIndex == nextVideos.length || (maxAutoplay >= 0 && playCount >= maxAutoplay)){

			}

			// if video found and not last, set nextVideo
			else if (curIndex >= 0) {
				nextVideo = nextVideos[curIndex];
			}

			//else not found, default next to first in list
			else if (curIndex == -1) {
				if (autoplay) {
					nextVideo = nextVideos[0];
				}
			}

			if (nextVideo) {
				logger.info('getNext - next id:%o title:%o', nextVideo.cmsId, nextVideo.title);
				showNextup(nextVideo, true);
			}
			else {
				logger.info('getNext - on last video');
			}

		};

		/**
		 * cancel any pending up next display/countdown
		 */
		var cancel = function() {
			$('.nextup').hide();
			removeInterval();
		};

		/**
		 * update autoplay setting
		 */
		var toggleAutoplay = function() {
			var userAuto = (Cookies.get('videoAutoplay') == "true");
			logger.info('toggleAutoplay - userAuto: %o', userAuto);

			if (userAuto) {
				Cookies.set('videoAutoplay', "false", { path: '/' });
				userAuto = false;
			}
			else {
				Cookies.set('videoAutoplay', "true", { path: '/' });
				userAuto = true;
			}

			updateAutoplay();

			if (userAuto) {
				$('.nextup .countdown .label').show();
				$('.nextup .countdown .count').show();
				if (!countdownTimer){
					countdownTimer = setTimeout(function(){ updateCountdown() }, 1000);
				}
			}
			else {
				$('.nextup .countdown .label').hide();
				$('.nextup .countdown .count').hide();
				removeInterval();
			}
		};

		/**
		 * update autoplay button
		 */
		var updateAutoplay = function() {
			var userSet = (Cookies.get('videoAutoplay') == "true" || Cookies.get('videoAutoplay') == "false");
			userAuto = (Cookies.get('videoAutoplay') == "true");
			logger.info('updateAutoplay - userAuto: %o', userAuto);

			if (autoplay){
				if (!userSet) {
					userAuto = true;
					$('.nextup .allow a').html('disable autoplay');
				}
				else if (userAuto) {
					$('.nextup .allow a').html('disable autoplay');
				}
				else {
					$('.nextup .allow a').html('enable autoplay');
				}
			}
			else {
				$('.nextup .allow').hide();
			}

		};

		/**
		 * clear timer interval and set to null
		 */
		var removeInterval = function() {
			clearTimeout(countdownTimer);
			countdownTimer = null;
		};

		return {
			init: init,
			getNext: getNext,
			cancel: cancel
		};
	}

	wimbledonCore.VideoNextUp = VideoNextUp;
}(jQuery, window.wimbledonCore));
